module.exports = __webpack_public_path__ + "static/Usa lava-78d5ea47eb32f2a76d47432690a101cc.png";